import { EnglishArabicDTO } from "bnsights-control-library"
export class LookupGroupModel
{
      Id:number
      Name :EnglishArabicDTO=new EnglishArabicDTO();
      IDEncrypted :string
}
     